import i18n from 'i18next';
import config from 'i18n-config';
import { initReactI18next } from 'react-i18next';
import { getDatePlusYear } from './date-time-helpers';
import { createCookies } from './cookies';

export function initI18n(path = '', host = '') {
  let lang = 'ru';

  if (path.startsWith('/kz/')) {
    lang = 'kk';
  }

  const cookies = createCookies();
  const domain = `.${host}`;
  cookies.set('lang', lang, { path: '/', expires: getDatePlusYear(), domain });

  i18n.use(initReactI18next).init(config(lang));

  return lang;
}
